import {
  FETCH_SELECT_SCOPED_ANOMALY_RULE_REQUEST,
  FETCH_SELECT_SCOPED_ANOMALY_RULE_SUCCESS,
  FETCH_SELECT_SCOPED_ANOMALY_RULE_FAILURE,
  FETCH_SPECIFIC_ANOMALY_RULE_SUCCESS,
  FETCH_SPECIFIC_ANOMALY_RULE_FAILURE,
  CLEAR_SPECIFIC_ANOMALY_RULE,
  SELECT_ANOMALY_RULE_PAGE

} from "../_constants";

const initialState = {
  loading: false,
  selectScopedAnomalyRule: "",
  error: "",
  success: false,
  select: "",
  specificAnomalyRule: ''
};

export const selectScopedAnomalyRuleReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FETCH_SELECT_SCOPED_ANOMALY_RULE_REQUEST:
      return {
        ...state,
        loading: true,
        selectScopedAnomalyRule: "",
        error: "",
      };
    case FETCH_SELECT_SCOPED_ANOMALY_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        selectScopedAnomalyRule: action.payload,
        error: "",
      };
    case FETCH_SELECT_SCOPED_ANOMALY_RULE_FAILURE:
      return {
        ...state,
        loading: false,
        selectScopedAnomalyRule: "",
        error: action.payload,
      };
    case FETCH_SPECIFIC_ANOMALY_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        specificAnomalyRule: action.payload,
        error: "",
      };
    case FETCH_SPECIFIC_ANOMALY_RULE_FAILURE:
      return {
        ...state,
        loading: false,
        specificAnomalyRule: "",
        error: action.payload,
      };
      case CLEAR_SPECIFIC_ANOMALY_RULE:
      return {
        ...state,
        loading: false,
        specificAnomalyRule: "",
        selectScopedAnomalyRule: [],
        error: "",
      };
    case SELECT_ANOMALY_RULE_PAGE:
      return {
        ...state,
        loading: false,
        selectAnomalyRulePage: action.payload,
        error: "",
      };
    default:
      return state;
  }
};
